import { FormControl, FormGroup, Validators } from '@angular/forms';

import type { FormlyFieldConfig } from '@ngx-formly/core';

export const promoFormFields: FormlyFieldConfig[] = [
	{
		id: 'promoCode',
		key: 'promoCode',
		props: {
			className: 'uppercase',
			icon: 'assets/icons/icon-deal.svg',
			iconPosition: 'left',
			placeholder:
				'storyblok.pages.promotion-code.form.promo-code.placeholder',
			required: true,
			translate: true,
			validation: {
				messages: {
					inactive:
						'storyblok.pages.promotion-code.form.promo-code.errors.inactive',
					required:
						'storyblok.pages.promotion-code.form.promo-code.errors.required',
					notFound:
						'storyblok.pages.promotion-code.form.promo-code.errors.not-found',
				},
			},
		},
		type: 'text',
	},
];

export const promoFormGroup = new FormGroup({
	promoCode: new FormControl<string>('', {
		nonNullable: true,
		validators: [Validators.required],
	}),
});
